'use no memo';

import { createFileRoute, useParams } from '@tanstack/react-router';
import { useCallback } from 'react';
import type { ApiError } from '@/lib/api/error';
import { DraftAttributeRendererWrapper } from '../-components';
import { SectionFormWrapper, prefetchDraftCatalog, useSaveDraftCatalog, type DeviceCatalogSection } from '../-shared';
export const Route = createFileRoute('/_staff/device-catalog/draft/$id/_layout/profile/')({
  component: DraftProfile,
  loader: prefetchDraftCatalog
});
function useDraftProfileSaveMutation(options?: {
  onSuccess?: () => void;
  onError?: (error: ApiError) => void;
}) {
  const {
    id
  } = useParams({
    from: '/_staff/device-catalog/draft/$id/_layout/profile/'
  });
  return useSaveDraftCatalog(id, options);
}
function DraftProfile() {
  const renderSectionContent = useCallback((section: DeviceCatalogSection) => <DraftAttributeRendererWrapper attributes={section.attributes} sectionKey={String(section.sectionKey)} displayOrder={section.displayOrder} />, []);
  return <SectionFormWrapper useSaveMutation={useDraftProfileSaveMutation} renderSectionContent={renderSectionContent} />;
}